<template>
	<brows-layout @edit="$emit('edit')" @next="$emit('next')" class="ceritficate color-text2">
		<div class="tips">*此為顯示於證書之姓名，請再三確認，送出後不可修改，建議使用威妥瑪(WG)拼音
			<br /><a href="https://www.boca.gov.tw/sp-natr-singleform-1.html" target="_blank" class="color-blue1">外交部外文姓名中譯英系統查詢</a>
		</div>
		<p style="color:red;">羅馬拼音撰寫範例：王小明 WANG,HSIAO-MING （姓,名-名）</p>
		<br>
		<div class="layout-row">
			<div class="imformation layout-column">
				<div class="team-member">
					<div class="title" v-if="!is18">超級英雄姓名拼音</div>
					<div class="title" v-else>夥伴姓名拼音</div>
					<div class="content">
						<div class="member layout-row" v-for="(member, i) in editStoryData.team_members" :key="i">
							<div class="name color-black">{{member.name}}</div>
							<div class="detail">
								<div class="detail-item layout-column">
									<div class="lable">姓名羅馬拼音</div>
									<div class="name color-danger" v-if="!member.wade_giles">尚未填寫</div>
									<div class="data color-black" v-else>{{member.wade_giles}}</div>
								</div>
								<div class="detail-item layout-column">
									<div class="lable">所屬單位(英文)</div>
									<div class="name color-danger" v-if="!member.department_en">尚未填寫</div>
									<div class="data color-black" v-else>{{member.department_en}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="instructor">
					<div class="title" v-if="!is18">輔導員姓名拼音</div>
					<div class="title" v-else>代表人姓名拼音</div>
					<div class="content">
						<div class="member layout-row" v-for="(member, i) in editStoryData.counselors" :key="i">
							<div class="name color-black">{{member.name}}</div>
							<div class="detail">
								<div class="detail-item layout-column">
									<div class="lable">姓名羅馬拼音</div>
									<div class="name color-danger" v-if="!member.wade_giles">尚未填寫</div>
									<div class="data color-black" v-else>{{member.wade_giles}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div>
					<div class="title">證書寄送地址</div>
					<div class="content">
						<div>
							<p class="name color-danger" v-if="!certificate_address.recipient">尚未填寫</p>
							<p class="data color-black" v-else>{{certificate_address.recipient}}</p>
						</div>
						<div>
							<template v-if="certificate_address.zip || certificate_address.city || certificate_address.address">
								<p class="data color-black">{{certificate_address.zip}}&nbsp;{{certificate_address.city}}&nbsp;{{certificate_address.address}}</p>
							</template>
							<p class="name color-danger" v-else>尚未填寫</p>
						</div>
						<p class="data color-black">{{certificate_address.note}}</p>
					</div>
				</div>
			</div>
			<div class="example">
				<div class="title">國際證書範本</div>
				<img src="../../../../assets/award.jpg" style="width:100%; max-width:300px;">
			</div>
		</div>
	</brows-layout>
</template>

<script>
import BrowsLayout from "./BrowsLayout.vue";
import { mapState } from "vuex";

export default {
	props: ["is18"],
	data() {
		return {};
	},
	computed: {
		...mapState("story", ["editStoryData"]),
		certificate_address() {
			return this.editStoryData.certificate_address || new Object
		}
	},
	methods: {},
	created() { },
	mounted() { },
	components: { BrowsLayout }
};
</script>

<style lang="scss" scoped>
.ceritficate {
	font-size: 14px;

	.tips {
		margin-bottom: 31px;
	}

	.title {
		margin-bottom: 15px;
	}

	.imformation {
		width: 350px;
		margin-right: 40px;

		.team-member {
			margin-bottom: 10px;
		}

		.member {
			margin-bottom: 15px;
		}

		.content {
			padding-left: 20px;

			.name {
				width: 60px;
				margin-right: 20px;
			}
		}
	}
}
</style>